import React from 'react'

const NewsPage = ({ data }) => (
  <section className="main wrapper style2">
    <header className="major">
      <h2>News</h2>
    </header>
    <div className="container">
      <section>
        <div className="row">
          {data.allBlogEntries.edges.map(edge => {
            const post = edge.node
            return (
              <div
                className="blog-entry col-12 col-12-narrow col-12-mobilep"
                key={post.id}
              >
                <h3>{post.title}</h3>
                <h4>{post.date}</h4>
                <div
                  dangerouslySetInnerHTML={{ __html: post.content }}
                  className="content"
                />
                <hr />
              </div>
            )
          })}
        </div>
      </section>
    </div>
  </section>
)
          
export default NewsPage
export const postsQuery = graphql`
  query PostsQuery {
    allBlogEntries(
      sort: {fields: [date], order: DESC}
    ) {
      edges {
        node {
          id
          title
          date(formatString: "MMMM DD, YYYY")
          content
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/news.js